import React from "react"
import PropTypes from "prop-types"
import {Row, Col} from "react-bootstrap"
import styled from "styled-components"
import {FormattedMessage} from "@irati/utils/lang"

const EmailWrapper = styled.span`
  word-wrap: break-word;
`
const SelectedEmail = ({email}) => (
  <div className="orderSummarySelectedEmail">
    <Row>
      <Col xs={2}>
        <div><FormattedMessage id="perks.components.orderSummary.selectedEmail.email" /></div>
      </Col>
      <Col xs={10}>
        <EmailWrapper>{email}</EmailWrapper>
      </Col>
    </Row>
    <hr />
  </div>
)

SelectedEmail.propTypes = {
  email: PropTypes.string.isRequired
}
export default SelectedEmail
